import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const RedirectToDefaultCountry = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const country = params.get("country");

    console.log("country", country);

    if (country) {
      // Redirect to new format using query param value
      navigate(`/${country}`, { replace: true });
    } else {
      // No country param: default to "SA"
      navigate(`/saudiarabia`, { replace: true });
    }
  }, [navigate, location]);

  return null;
};

export default RedirectToDefaultCountry;
